import { SelectComponentValue } from '../viewModels/common/SelectComponentValue';

export enum Platforms {
  NotSelected = 0,
  TMS = 5,
  ClientPortal = 10,
  MobileApp = 15,
  API = 20,
}

export enum WeekDays {
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
  Sunday = 7,
}

export enum InvoiceFrequency {
  NotSelected = 0,
  EveryMonth = 1,
  Quarterly = 2,
  HalfYearly = 3,
  Yearly = 4,
}

export enum PackageTypeGroup {
  NotSelected = 0,
  Pallet = 1,
  Package = 2,
  LoadingMeter = 3,
  FullTruck = 4,
  Container = 5,
}

export enum FleetType {
  NotSelected = 0,
  Vehicle = 1,
  Forklift = 2,
  CraneTruck = 3,
  TractorUnit = 4,
  Van = 5,
  TailLiftTruck = 9,
  Truck = 10,
  BoxSemiTrailer = 16,
  Tautliner = 17,
  FlatbedTrailer = 20,
  MegaTrailer = 21,
  RefrigeratedTrailer = 22,
  FullTrailer = 23,
  Container = 25,
  ContainerTruck = 30,
}

export enum CustomerPosition {
  NotSelected = 0,
  Logistics = 'Logistics',
  Warehouse = 'Warehouse',
  Sales = 'Sales',
  Accounting = 'Accounting',
  Other = 'Other',
}

export enum ShipmentStatus {
  NotSelected = 0,
  Draft = 1,
  Canceled = 5,
  Received = 10,
  Processing = 15,
  InTransit = 20,
  Delivered = 25,
}

export enum ShipmentStatusProblem {
  NotSelected = 0,
  Missing = 1,
  PartlyMissing = 2,
  NotCollected = 10,
  IncorrectPickupInformation = 11,
  PalletsAndGoodsHeightHigherThanPermitted = 12,
  CollectionBusinessClosed = 13,
  DamagedInTheCourseOfTransportation = 20,
  DamagedDuringManipulationInWarehouse = 21,
  WeatherConditions = 30,
  DestinationIncorrect = 40,
  SortedToWrongRoute = 41,
  SpecialUnloadingOperations = 42,
  DeliveryBusinessClosed = 43,
  DeliveryRefusedByRecipient = 44,
  DeliveryConsigneeAbsent = 45,
  PackageAdjustment = 50,
  Specify = 99,
}

export enum PriceRequestStatus {
  NotSelected = 0,
  Draft = 1,
  Expired = 2,
  Canceled = 5,
  Received = 10,
  WaitingConfirmed = 20,
  Accepted = 25,
  Rejected = 30,
}

export enum PriceRequestRejectReason {
  NotSelected = 0,
  TooHighPrice = 1,
  Postpone = 2,
  DeliveryNotNeedAnyMore = 3,
  SomethingElse = 4,
}

export enum ShippingOrderStatus {
  NotSelected = 0,
  Draft = 1,
  Processing = 2,
  Canceled = 5,
  Collected = 10,
  InTransit = 20,
  Delivered = 25,
}

export enum ShipmentType {
  NotSelected = 0,
  Sender = 5,
  Receiver = 10,
}

export enum InvoicePriceType {
  NotSelected = 0,
  TransportDomestic = 1,
  TransportEU = 8,
  Transport = 9,
  HomeDelivery = 2,
  Customs = 3,
  Storage = 4,
  Insurance = 5,
  ForwardedTransportService = 6,
  LogisticsManagement = 7,
  Other = 100,
}

export enum InvoiceType {
  NotSelected = 0,
  Sales = 1,
  Purchase = 2,
}

export enum InvoiceStatus {
  NotSelected = 0,
  Draft = 5,
  Sent = 10,
  Paid = 15,
}

export enum UploadEntities {
  NotSelected = 0,
  TenantLogo = 1,
  Translations = 2,
  CustomerImport = 3,
  Shipment = 5,
  ShipmentPod = 6,
  ShippingOrder = 10,
}

export enum SavedFilterView {
  NotSelected = 0,
  Shipment = 2,
  ShipmentClientPortal = 3,
  ShippingOrder = 4,
  Inbox = 6,
  PriceRequest = 8,
  Project = 10,
}

export enum MessageTemplateType {
  NotSelected = 0,
  NoticeInvoice = 6,
  ShippingOrderForPartner = 7,
  SpotRequestEmail = 9,
}

export enum SpotRequestStatus {
  NotSelected = 0,
  Draft = 5,
  WaitingPrices = 10,
  PricesOffered = 11,
  Rejected = 15,
  Approved = 20,
  Expired = 25,
}

export enum SpotRequestEntity {
  NotSelected = 0,
  Shipment = 5,
  ShippingOrder = 10,
  PriceRequest = 15,
}

export const enum RouteAddressActivityType {
  Pickup = 'pickup',
  Delivery = 'delivery',
  Waypoint = 'waypoint',
}

export enum TenantBusinessArea {
  NotSelected = 0,
  Forwarder = 1,
  Carrier = 2,
}

export const Incoterms: SelectComponentValue[] = [
  { value: 'DAP', label: 'DAP', isActive: true },
  { value: 'EXW', label: 'EXW', isActive: true },
  { value: 'FCA', label: 'FCA', isActive: true },
  { value: 'CPT', label: 'CPT', isActive: true },
  { value: 'CIP', label: 'CIP', isActive: true },
  { value: 'DAT', label: 'DAT', isActive: true },
  { value: 'DDP', label: 'DDP', isActive: true },
  { value: 'FAS', label: 'FAS', isActive: true },
  { value: 'FOB', label: 'FOB', isActive: true },
  { value: 'CFR', label: 'CFR', isActive: true },
  { value: 'CIF', label: 'CIF', isActive: true }
];

export const TenantBusinessAreas: SelectComponentValue[] = [
  {
    value: TenantBusinessArea.Forwarder.toString(),
    label: 'Forwarder',
    isActive: true,
  },
  {
    value: TenantBusinessArea.Carrier.toString(),
    label: 'Carrier',
    isActive: true,
  },
];
export const TimeZones: SelectComponentValue[] = [
  {
    value: 'Morocco Standard Time',
    label: '(GMT) Casablanca',
    isActive: true,
  },
  {
    value: 'GMT Standard Time',
    label: '(GMT) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London',
    isActive: true,
  },
  {
    value: 'Greenwich Standard Time',
    label: '(GMT) Monrovia, Reykjavik',
    isActive: true,
  },
  {
    value: 'W. Europe Standard Time',
    label: '(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
    isActive: true,
  },
  {
    value: 'Central Europe Standard Time',
    label: '(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague',
    isActive: true,
  },
  {
    value: 'Romance Standard Time',
    label: '(GMT+01:00) Brussels, Copenhagen, Madrid, Paris',
    isActive: true,
  },
  {
    value: 'Central European Standard Time',
    label: '(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb',
    isActive: true,
  },
  {
    value: 'W. Central Africa Standard Time',
    label: '(GMT+01:00) West Central Africa',
    isActive: true,
  },
  {
    value: 'Jordan Standard Time',
    label: '(GMT+02:00) Amman',
    isActive: true,
  },
  {
    value: 'GTB Standard Time',
    label: '(GMT+02:00) Athens, Bucharest, Istanbul',
    isActive: true,
  },
  {
    value: 'Middle East Standard Time',
    label: '(GMT+02:00) Beirut',
    isActive: true,
  },
  {
    value: 'Egypt Standard Time',
    label: '(GMT+02:00) Cairo',
    isActive: true,
  },
  {
    value: 'South Africa Standard Time',
    label: '(GMT+02:00) Harare, Pretoria',
    isActive: true,
  },
  {
    value: 'FLE Standard Time',
    label: '(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius',
    isActive: true,
  },
  {
    value: 'Israel Standard Time',
    label: '(GMT+02:00) Jerusalem',
    isActive: true,
  },
  {
    value: 'E. Europe Standard Time',
    label: '(GMT+02:00) Minsk',
    isActive: true,
  },
  {
    value: 'Namibia Standard Time',
    label: '(GMT+02:00) Windhoek',
    isActive: true,
  },
  {
    value: 'Arabic Standard Time',
    label: '(GMT+03:00) Baghdad',
    isActive: true,
  },
  {
    value: 'Arab Standard Time',
    label: '(GMT+03:00) Kuwait, Riyadh',
    isActive: true,
  },
  {
    value: 'Russian Standard Time',
    label: '(GMT+03:00) Moscow, St. Petersburg, Volgograd',
    isActive: true,
  },
  {
    value: 'E. Africa Standard Time',
    label: '(GMT+03:00) Nairobi',
    isActive: true,
  },
  {
    value: 'Georgian Standard Time',
    label: '(GMT+03:00) Tbilisi',
    isActive: true,
  },
  {
    value: 'Iran Standard Time',
    label: '(GMT+03:30) Tehran',
    isActive: true,
  },
  {
    value: 'Arabian Standard Time',
    label: '(GMT+04:00) Abu Dhabi, Muscat',
    isActive: true,
  },
  {
    value: 'Azerbaijan Standard Time',
    label: '(GMT+04:00) Baku',
    isActive: true,
  },
  {
    value: 'Mauritius Standard Time',
    label: '(GMT+04:00) Port Louis',
    isActive: true,
  },
  {
    value: 'Caucasus Standard Time',
    label: '(GMT+04:00) Yerevan',
    isActive: true,
  },
  {
    value: 'Afghanistan Standard Time',
    label: '(GMT+04:30) Kabul',
    isActive: true,
  },
  {
    value: 'Ekaterinburg Standard Time',
    label: '(GMT+05:00) Ekaterinburg',
    isActive: true,
  },
  {
    value: 'Pakistan Standard Time',
    label: '(GMT+05:00) Islamabad, Karachi',
    isActive: true,
  },
  {
    value: 'West Asia Standard Time',
    label: '(GMT+05:00) Tashkent',
    isActive: true,
  },
  {
    value: 'India Standard Time',
    label: '(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi',
    isActive: true,
  },
  {
    value: 'Sri Lanka Standard Time',
    label: '(GMT+05:30) Sri Jayawardenepura',
    isActive: true,
  },
  {
    value: 'Nepal Standard Time',
    label: '(GMT+05:45) Kathmandu',
    isActive: true,
  },
  {
    value: 'N. Central Asia Standard Time',
    label: '(GMT+06:00) Almaty, Novosibirsk',
    isActive: true,
  },
  {
    value: 'Central Asia Standard Time',
    label: '(GMT+06:00) Astana, Dhaka',
    isActive: true,
  },
  {
    value: 'Myanmar Standard Time',
    label: '(GMT+06:30) Yangon (Rangoon)',
    isActive: true,
  },
  {
    value: 'SE Asia Standard Time',
    label: '(GMT+07:00) Bangkok, Hanoi, Jakarta',
    isActive: true,
  },
  {
    value: 'North Asia Standard Time',
    label: '(GMT+07:00) Krasnoyarsk',
    isActive: true,
  },
  {
    value: 'China Standard Time',
    label: '(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi',
    isActive: true,
  },
  {
    value: 'North Asia East Standard Time',
    label: '(GMT+08:00) Irkutsk, Ulaan Bataar',
    isActive: true,
  },
  {
    value: 'Singapore Standard Time',
    label: '(GMT+08:00) Kuala Lumpur, Singapore',
    isActive: true,
  },
  {
    value: 'W. Australia Standard Time',
    label: '(GMT+08:00) Perth',
    isActive: true,
  },
  {
    value: 'Taipei Standard Time',
    label: '(GMT+08:00) Taipei',
    isActive: true,
  },
  {
    value: 'Tokyo Standard Time',
    label: '(GMT+09:00) Osaka, Sapporo, Tokyo',
    isActive: true,
  },
  {
    value: 'Korea Standard Time',
    label: '(GMT+09:00) Seoul',
    isActive: true,
  },
  {
    value: 'Yakutsk Standard Time',
    label: '(GMT+09:00) Yakutsk',
    isActive: true,
  },
  {
    value: 'Cen. Australia Standard Time',
    label: '(GMT+09:30) Adelaide',
    isActive: true,
  },
  {
    value: 'AUS Central Standard Time',
    label: '(GMT+09:30) Darwin',
    isActive: true,
  },
  {
    value: 'E. Australia Standard Time',
    label: '(GMT+10:00) Brisbane',
    isActive: true,
  },
  {
    value: 'AUS Eastern Standard Time',
    label: '(GMT+10:00) Canberra, Melbourne, Sydney',
    isActive: true,
  },
  {
    value: 'West Pacific Standard Time',
    label: '(GMT+10:00) Guam, Port Moresby',
    isActive: true,
  },
  {
    value: 'Tasmania Standard Time',
    label: '(GMT+10:00) Hobart',
    isActive: true,
  },
  {
    value: 'Vladivostok Standard Time',
    label: '(GMT+10:00) Vladivostok',
    isActive: true,
  },
  {
    value: 'Central Pacific Standard Time',
    label: '(GMT+11:00) Magadan, Solomon Is., New Caledonia',
    isActive: true,
  },
  {
    value: 'New Zealand Standard Time',
    label: '(GMT+12:00) Auckland, Wellington',
    isActive: true,
  },
  {
    value: 'Fiji Standard Time',
    label: '(GMT+12:00) Fiji, Kamchatka, Marshall Is.',
    isActive: true,
  },
  {
    value: 'Tonga Standard Time',
    label: "(GMT+13:00) Nuku'alofa",
    isActive: true,
  },
  {
    value: 'Azores Standard Time',
    label: '(GMT-01:00) Azores',
    isActive: true, 
  },
  {
    value: 'Cape Verde Standard Time',
    label: '(GMT-01:00) Cape Verde Is.',
    isActive: true,
  },
  {
    value: 'Mid-Atlantic Standard Time',
    label: '(GMT-02:00) Mid-Atlantic',
    isActive: true,
  },
  {
    value: 'E. South America Standard Time',
    label: '(GMT-03:00) Brasilia',
    isActive: true,
  },
  {
    value: 'Argentina Standard Time',
    label: '(GMT-03:00) Buenos Aires',
    isActive: true,
  },
  {
    value: 'SA Eastern Standard Time',
    label: '(GMT-03:00) Georgetown',
    isActive: true,
  },
  {
    value: 'Greenland Standard Time',
    label: '(GMT-03:00) Greenland',
    isActive: true,
  },
  {
    value: 'Montevideo Standard Time',
    label: '(GMT-03:00) Montevideo',
    isActive: true,
  },
  {
    value: 'Newfoundland Standard Time',
    label: '(GMT-03:30) Newfoundland',
    isActive: true,
  },
  {
    value: 'Atlantic Standard Time',
    label: '(GMT-04:00) Atlantic Time (Canada)',
    isActive: true,
  },
  {
    value: 'SA Western Standard Time',
    label: '(GMT-04:00) La Paz',
    isActive: true,
  },
  {
    value: 'Central Brazilian Standard Time',
    label: '(GMT-04:00) Manaus',
    isActive: true,
  },
  {
    value: 'Pacific SA Standard Time',
    label: '(GMT-04:00) Santiago',
    isActive: true,
  },
  {
    value: 'Venezuela Standard Time',
    label: '(GMT-04:30) Caracas',
    isActive: true,
  },
  {
    value: 'SA Pacific Standard Time',
    label: '(GMT-05:00) Bogota, Lima, Quito, Rio Branco',
    isActive: true,
  },
  {
    value: 'Eastern Standard Time',
    label: '(GMT-05:00) Eastern Time (US & Canada)',
    isActive: true,
  },
  {
    value: 'US Eastern Standard Time',
    label: '(GMT-05:00) Indiana (East)',
    isActive: true,
  },
  {
    value: 'Central America Standard Time',
    label: '(GMT-06:00) Central America',
    isActive: true,
  },
  {
    value: 'Central Standard Time',
    label: '(GMT-06:00) Central Time (US & Canada)',
    isActive: true,
  },
  {
    value: 'Central Standard Time (Mexico)',
    label: '(GMT-06:00) Guadalajara, Mexico City, Monterrey',
    isActive: true,
  },
  {
    value: 'Canada Central Standard Time',
    label: '(GMT-06:00) Saskatchewan',
    isActive: true,
  },
  {
    value: 'US Mountain Standard Time',
    label: '(GMT-07:00) Arizona',
    isActive: true,
  },
  {
    value: 'Mountain Standard Time (Mexico)',
    label: '(GMT-07:00) Chihuahua, La Paz, Mazatlan',
    isActive: true,
  },
  {
    value: 'Mountain Standard Time',
    label: '(GMT-07:00) Mountain Time (US & Canada)',
    isActive: true,
  },
  {
    value: 'Pacific Standard Time',
    label: '(GMT-08:00) Pacific Time (US & Canada)',
    isActive: true,
  },
  {
    value: 'Pacific Standard Time (Mexico)',
    label: '(GMT-08:00) Tijuana, Baja California',
    isActive: true,
  },
  {
    value: 'Alaskan Standard Time',
    label: '(GMT-09:00) Alaska',
    isActive: true,
  },
  {
    value: 'Hawaiian Standard Time',
    label: '(GMT-10:00) Hawaii',
    isActive: true,
  },
  {
    value: 'Samoa Standard Time',
    label: '(GMT-11:00) Midway Island, Samoa',
    isActive: true,
  },
  {
    value: 'Dateline Standard Time',
    label: '(GMT-12:00) International Date Line West',
    isActive: true,
  },
];
